<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
data() {
  return {
    errors: {},
    title: "Sales",
    text: "Sales",
    text1: "Invoices",
    toast: useToast(),
    admin: [],
    banks: [],
    previewData: null
  };
},

 created() {
  this.loadPreviewData();
 },

methods: {

 loadPreviewData(){
  const previewId = this.$route.params.id;
  const storedData = sessionStorage.getItem(`preview_${previewId}`);

  if(storedData){
   this.previewData = JSON.parse(storedData);
   // Optionally remove from storage after loading
   sessionStorage.removeItem(`preview_${previewId}`);
   this.adminDetail(this.clientAdmin.id);
   this.adminBanks(this.clientAdmin.id);
  }
 },   

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<template>
 <div class="content mt-2 mb-3">
  
  <!-- Invoices -->
<div style="width:185mm; min-height:297mm; margin:auto; padding:0px; box-sizing:border-box; border:1px solid #ccc;">

  <!-- Header -->
  <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
    <tr>
      <th colspan="2" style="font-size:20px; font-weight:600; text-align:center; background:#444; color:#fff; padding:10px; letter-spacing:1px;">
         INVOICE
      </th>
    </tr>
    <tr>
	
     <td style="width:40%; padding:10px; border:1px solid #ddd; vertical-align:top;">
       <img :src="$clientLogo(admin.company?.logo, admin)" :alt="admin.company?.company_name" style="width:180px; height:auto; margin-bottom:6px;"><br>
     </td>
     <td style="width:60%; padding:10px; border:1px solid #ddd; text-align:right; vertical-align:top; line-height:1.5;">
      <h2 style="margin:0; font-size:18px; color:#222;">{{ admin?.company?.company_name }}</h2>
       
      <p style="margin:2px 0;" v-if="admin?.company?.email">Email: <strong> {{ admin?.company?.email }}</strong></p>
       
      <p style="margin:2px 0;">Address: <strong>{{ admin?.company?.address }} {{ admin?.company?.city }}, {{ admin?.company?.state }} {{ admin?.company?.country }} - {{ admin?.company?.pincode }}</strong></p>
      
      <p style="margin:2px 0;">Phone: <strong>: {{ admin?.company?.mobile }}</strong></p> 

      <p style="margin:2px 0;" v-if="admin?.company?.gst">GSTIN: <strong>: {{ admin?.company?.gst }}</strong></p>
        
      </td>
    </tr>
    <tr>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;font-size:15px;color:#000;"><strong> Billing To</strong></p>
       
        <p style="margin:2px 0;">{{ previewData.to_name }}
         <span v-if="previewData.to_phone"><br> {{ previewData.to_phone }}</span>
         <span v-if="previewData.to_email"><br> {{ previewData.to_email }}</span>
         <span v-if="previewData.to_address"><br> {{ previewData.to_address }}, {{ previewData.to_city }}, {{ previewData.to_state }}, {{ previewData.to_country }} - {{ previewData.to_pincode }}</span>
         <span v-if="previewData.gst_no"><br> GSTIN: {{ previewData.gst_no }}</span>
        </p>
        
      </td>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
       <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr>
    <td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Invoice Date</strong><br> {{ $formatDate(previewData?.issue_date, 'DD MMM YYYY') }}</td>
	<td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Invoice No</strong><br> {{ previewData?.invoice_number }}</td>
	</tr>
	<tr>
    <td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Deal No.</strong><br> {{ previewData?.quotation?.quotation_number ?? "N/A" }}</td>

	<td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Place of Supply</strong><br> {{previewData?.place_of_supply ?? "N/A"}}</td>
	</tr>
	<tr>
    <td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>PO No.</strong><br>{{previewData?.po_number ?? "N/A"}}</td>
	<td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>PO Date</strong><br>{{ previewData?.po_date ? $formatDate(previewData?.po_date, 'DD MMM YYYY') : "N/A"  }}</td>
	</tr>
	<tr>
    <td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Vendor No.</strong><br>{{previewData?.vendor_number ?? "N/A"}}</td>
	<td style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Due Date</strong><br>{{ previewData?.due_date ? $formatDate(previewData?.due_date, 'DD MMM YYYY') : "N/A" }}</td>
	</tr>
	<tr>
    <td colspan="2" style="border:1px solid #ddd; padding:6px; text-align:center;"><strong>Vehicle No.</strong><br>{{previewData?.vehicle_number ?? "N/A"}}</td>
	</tr>
	  
    
  </table>
	   
      </td>
    </tr>
   <!-- <tr>
      <td colspan="2" style="padding:10px; border:1px solid #ddd; text-align:left; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Subject:</strong> </p>
        <div class="dynamic">
         
        </div>
      </td>
    </tr>-->
  </table>

  <!-- Product Table -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr style="background:#f2f2f2;">
      <th style="border:1px solid #ddd; padding:6px;">S.No.</th>
      <th style="border:1px solid #ddd; padding:6px;">Title</th>
      <th style="border:1px solid #ddd; padding:6px;">HSN/SAC</th>
	   <th style="border:1px solid #ddd; padding:6px;">Price</th>
      <th style="border:1px solid #ddd; padding:6px;">Quantity</th>
      <th style="border:1px solid #ddd; padding:6px;">Sub Total</th>
     <th style="border:1px solid #ddd; padding:6px;" v-if="previewData.tax_mode === 'Item'">Tax</th> 
      <th style="border:1px solid #ddd; padding:6px;">Final Amount</th>
      <!-- <th style="border:1px solid #ddd; padding:6px;">SKU</th> -->
    </tr>
    
    <tr v-for="(row, index) in previewData.items" :key="index">
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{index + 1}}</td>
      <td style="border:1px solid #ddd; padding:6px; line-height:1.4;text-align:center">{{row.name}}
        <p v-if="row.description" style="margin-bottom:0;" v-html="row.description"></p>
      </td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;"> {{row.hsn_code ?? 'N/A'}} </td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;"> {{row.price}} </td>
	   <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{row.qty}} {{row.unit}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{row.amount}}</td>
     <td style="border:1px solid #ddd; padding:6px; text-align:center;" v-if="previewData.tax_mode === 'Item'">{{row?.taxName}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center; font-weight:600;">{{row.totalWithTax.toFixed(2)}}</td>
      <!-- <td style="border:1px solid #ddd; padding:6px; text-align:center; font-weight:600;"> 7301</td> -->
    </tr>
    
  </table>

<table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
   
    <tr>
      <td style="width:50%;padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
      
      </td>
      <td style="width:50%;padding:10px; border-bottom:1px solid #ddd; vertical-align:top; line-height:1.5;text-align:right">
	  <span><strong> Sub Total &nbsp;&nbsp; &nbsp;&nbsp; </strong></span> <span>{{ previewData.totalAmount }}</span><br>
    
    <span>
    <strong>{{ previewData.tax_mode === 'Invoice' ? `Tax: ${previewData.tax_name}` : 'Item Taxes' }}:</strong> {{ previewData.taxAmount }}<br>
    </span>

    <span v-if="parseFloat(previewData.discount) > 0">
    <strong>Discount:</strong> {{ previewData.discount }}<br>
    </span>

    <span v-if="parseFloat(previewData.transportation_cost) > 0">
    <strong>Transportation Cost:</strong> {{ previewData.transportation_cost }}<br>
    </span>
    
    <span v-if="parseFloat(previewData.installation_cost) > 0">
    <strong>Installation Cost:</strong> {{ previewData.installation_cost }}<br>
    </span>

	  <span><strong> Total &nbsp;&nbsp;&nbsp;&nbsp; </strong></span> <span>{{ `${previewData.currency} ${previewData.grandTotal}` }}</span><br>
	  <span style="font-size:12px">({{ $amountInWords(previewData.grandTotal) }})</span><hr>
	  <span><strong> Balance &nbsp;&nbsp; &nbsp;&nbsp; </strong></span> <span>{{ `${previewData.currency} ${previewData.grandTotal}` }}</span><br>
     
      </td>
	  
    </tr>
 
  </table>
  <!-- Terms -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;" v-if="previewData.terms">
    <tr>
      <td style="border:1px solid #ddd; padding:10px; line-height:1.6;">
        <p><strong><u>Terms & Conditions</u></strong></p>
        <div class="dynamic">
         <div v-html="previewData.terms"></div>
        </div>
      </td>
    </tr>
  </table>


 <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">   
  <tr>
  <td style="width:60%;padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;" v-if="previewData.notes">
   <strong>Note:</strong><br>
   <div v-html="previewData.notes"></div>
  </td>
  <td style="width:40%;padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
  <p style="margin:2px 0;text-align:right">{{admin.company?.company_name}}</p>
    <p style="margin:2px 0;text-align:right"> <img src="" style="width:120px; height:auto; margin-bottom:5px;"><br>
  <strong style="font-size:15px;">Authorised Signatory</strong>
  <img :src="$clientSignature(admin.company?.signature, admin)" style="width:120px; height:auto; margin-bottom:5px;">
    </p>
  </td>
  </tr>
 
  </table>
 
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
  <tr>
  <td style="border:1px solid #ddd; padding:10px; line-height:1.6;">
   <strong>Sales Person Info</strong><br>
    {{ auth?.name }}<br>
    {{ auth?.mobile }}<br>
    {{ auth?.email }}
  </td>
  </tr>
  </table>


</div>
  <!-- /Invoices -->

    <!-- <div class="d-flex justify-content-center align-items-center mb-4">
      <a href="javascript:void(0);" class="btn btn-primary d-flex justify-content-center align-items-center me-2"><i class="ti ti-printer me-2"></i>Print Invoice</a>
      <a href="javascript:void(0);" class="btn btn-white d-flex justify-content-center align-items-center border"><i class="ti ti-copy me-2"></i>Clone Invoice</a>
    </div> -->
  </div>


</template>
